<template>
  <div class="user-org-users-control_usc org-admin_oam" :class="{ [curTheme]: true }">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>
    <nav-user-orgs/>

    <div class="page-container_pcr">
      <h2 class="oam_page-title">Жалобы организации</h2>
    </div>

    <nav-user-org-page/>

    <div class="page-container_pcr">

      <h3 class="oam_inner-title">Работа с жалобами</h3>

    </div>

    <div class="page-container_pcr">

      <div
        v-if="$store.getters['user/isSysAdmin']"
        class="oam_filter_oaf"
        style="margin-bottom: 35px">
        <div class="oaf_cells oaf_cells-2">
          <div class="oaf_cell text-center" style="padding-bottom: 0">
            <button
              @click="fetchData(false, true)"
              class="normal-button"
              :class="{ 'normal-button--on': !showAllClaims }"
              style="width: 100%">
              Жалобы организации</button>
          </div>
          <div class="oaf_cell text-center" style="padding-bottom: 0">
            <button
              @click="fetchData(true, true)"
              class="normal-button"
              :class="{ 'normal-button--on': showAllClaims }"
              style="width: 100%">
              Все жалобы платформы</button>
          </div>
        </div>
      </div>

      <el-dialog
        v-if="reviewData"
        class="usc_review-claim-win"
        title="Комментарий или рецензия"
        :visible.sync="reviewWinOn">
        <div class="usc_win-row usc_win-row--inline">
          <div class="usc_win-label">Тип:</div>
          <div class="usc_win-text">
            {{ reviewData.Type === 'review' ? 'Отзыв' : 'Комментарий' }}
          </div>
        </div>
        <div class="usc_win-row usc_win-row--inline">
          <div class="usc_win-label">Автор:</div>
          <div class="usc_win-text">
            <a :href="`/user/${reviewData.Author.UserId}/profile/view`"
              target="_blank">
              {{ fio(reviewData.Author) }}
            </a>
          </div>
        </div>
        <div class="usc_win-row usc_win-row--inline">
          <div class="usc_win-label">Дата создания:</div>
          <div class="usc_win-text">
            {{ timeToDate(reviewData.CreatedTime) }}
          </div>
        </div>
        <div class="usc_win-row usc_win-row--inline">
          <div class="usc_win-label">Объект:</div>
          <div class="usc_win-text">
            <a :href="`/object/${reviewData.ObjectId}`" target="_blank">
            открыть страницу объекта
            </a>
          </div>
        </div>
        <div class="usc_win-row">
          <div class="usc_win-label">Содержание:</div>
          <nl2br :text="reviewData.Text" class="usc_win-text" tag="div"/>
        </div>
        <div slot="footer" class="dialog-footer buttons-wrap">
          <button
            class="dialog-primary-btn"
            @click="reviewWinOn = false">
            Закрыть окно
          </button>
        </div>
      </el-dialog>

      <el-dialog
        v-if="activeClaim"
        class="usc_answer-win"
        title="Ответ на жалобу"
        :visible.sync="answerWinOn">
        <div class="usc_win-row">
          <div class="usc_win-label">Установить статус:</div>
          <div class="usc_win-text">
            <el-select v-model="answerStatus" placeholder="Select">
              <el-option
                v-for="(o, i) in answerStatuses"
                :key="`status-${i}`"
                :label="o.StatusTitle"
                :value="o.Status">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="usc_win-row" style="margin-top: 30px">
          <div class="usc_win-label">Ответ (опционально):</div>
          <div class="usc_win-text">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 20 }"
              placeholder="Введите текст ответа..."
              v-model="activeClaim.Answer"/>
          </div>
        </div>
        <div slot="footer" class="dialog-footer buttons-wrap">
          <button
            @click="saveAnswer"
            class="dialog-primary-btn">
            Сохранить ответ
          </button>
          <button
            @click="deleteAnswer"
            class="dialog-primary-btn">
            Удалить ответ
          </button>
          <button
            @click="deleteClaim"
            class="dialog-primary-btn usc_btn-xl">
            Удалить жалобу
          </button>
        </div>
      </el-dialog>

      <el-pagination
        v-show="pager.total > pager.pageSize"
        :page-size="pager.pageSize"
        :total="pager.total"
        :current-page.sync="pager.curPage"
        @current-change="pagerClicked"
        layout="prev, pager, next, jumper"/>

      <div class="data-table_dta" v-if="tableData.length">
        <table>
          <thead>
          <tr>
            <th>№</th>
            <th>Цель жалобы</th>
            <th>Время создания</th>
            <th>Автор</th>
            <th>Ответчик</th>
            <th>Текст жалобы</th>
            <th>Ответ</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="(o, i) in tableData" :key="`row-${i}`">
              <td class="text-center">
                {{ ((pager.curPage - 1 ) * pager.pageSize) + i + 1 }}</td>
              <td><a @click="openTarget(o)">{{ o.EntityTitle }}</a>
                <div class="usc_td-info">{{ o.EntityTypeTitle }}</div></td>
              <td class="text-center">{{ timeToDate(o.CreatedTime) }}</td>
              <td v-html="userProfile(o.Creator)" class="text-center"/>
              <td v-html="userProfile(o.Answerer)" class="text-center"/>
              <nl2br tag="td" :text="o.Message"/>
              <td class="text-center">
                <a @click="showAnswer(o)">
                  {{ (statuses.find((s) => s.Status === o.Status)).StatusTitle }}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <el-pagination
        v-show="pager.total > pager.pageSize"
        :page-size="pager.pageSize"
        :total="pager.total"
        :current-page.sync="pager.curPage"
        @current-change="pagerClicked"
        layout="prev, pager, next, jumper"/>

    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

import OrgAdminLayoutMixin from '@/components/layouts/org-admin/UserOrgLayoutMixin';

export default {

  mixins: [OrgAdminLayoutMixin],

  data() {
    return {
      // Whether to show all users of IPU if true
      // or only users of current org if false
      showAllClaims: false,
      reviewWinOn: false,
      reviewData: null,
      answerWinOn: false,
      filterDefaults: {
        limit: 20,
        offset: 0,
      },
      statuses: [
        { Status: 'PENDING', StatusTitle: 'Ожидает рассмотрения' },
        { Status: 'ACCEPTED', StatusTitle: 'Принята' },
        { Status: 'REJECTED', StatusTitle: 'Отклонена' },
      ],
      activeClaim: null,
      answerStatus: null,
    };
  },

  mounted() {
    this.$nextTick(this.fetchData);
  },

  computed: {

    answerStatuses() {
      return [this.statuses[1], this.statuses[2]];
    },

  },

  watch: {

    activeClaim() {
      this.answerStatus = (this.activeClaim.Status === this.statuses[0].Status) ?
        this.statuses[1].Status : this.activeClaim.Status;
    },

  },

  methods: {

    saveAnswer() {
      const claim = this.activeClaim;
      const params = {
        status: this.answerStatus,
        answer: claim.Answer,
      };
      Vue.$loading.on();
      axios.put(`claims/${claim.ClaimId}/answer`, params).then(() => {
        this.answerWinOn = false;
        this.$message.success('Статус жалобы и ответ сохранены.');
        this.fetchData();
      }).catch((err) => {
        this.$notify.error(err.response.data.join(' '));
        Vue.$loading.off();
      });
    },

    deleteAnswer() {
      Vue.$loading.on();
      axios.delete(`claims/${this.activeClaim.ClaimId}/answer`).then(() => {
        this.answerWinOn = false;
        this.$message.success('Ответ на жалобу удален.');
        this.fetchData();
      }).catch((err) => {
        this.$notify.error(err.response.data.join(' '));
        Vue.$loading.off();
      });
    },

    deleteClaim() {
      this.$confirm('Вы уверены, что хотите удалить жалобу?', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
      }).then(() => {
        Vue.$loading.on();
        axios.delete(`claims/${this.activeClaim.ClaimId}`).then(() => {
          this.answerWinOn = false;
          this.$message.success('Жалоба удалена.');
          this.fetchData();
        }).catch((err) => {
          this.$notify.error(err.response.data.join(' '));
          Vue.$loading.off();
        });
      }).catch(() => {});
    },

    showAnswer(claim) {
      this.activeClaim = claim;
      this.answerWinOn = true;
    },

    pagerClicked() {
      this.fetchData(this.showAllClaims);
    },

    userProfile(user) {
      if (!user) return '';
      const fio = this.fio(user);
      if (user.IsDeleted === false) {
        return `<a href="/user/${user.UserId}/profile/view"`
          + ` target="_blank">${fio}</a>`;
      }
      return fio;
    },

    openTarget(claim) {
      if (claim.EntityType === 'User') {
        window.open(`/user/${claim.EntityId}/profile/view`);
      } else if (claim.EntityType === 'Object') {
        window.open(`/object/${claim.EntityId}`);
      } else if (claim.EntityType === 'Review') {
        Vue.$loading.on();
        axios.get(`reviews/${claim.EntityId}`).then((r) => {
          this.reviewData = r.data;
          this.reviewWinOn = true;
          Vue.$loading.off();
        }).catch((err) => {
          Vue.$loading.off();
          this.$notify.error(err.response.data[0]);
        });
      }
    },

    fetchData(showAllClaims = false, fromStart = false) {
      if (typeof showAllClaims === 'undefined') {
        this.showAllClaims = false;
      } else {
        this.showAllClaims = showAllClaims;
      }
      if (fromStart) {
        this.pager.curPage = 1;
      }

      const orgId = this.$route.params.orgId;
      if (!orgId) {
        this.$notify.error('Не удалось определить организацию.');
        return;
      }

      Vue.$loading.on();
      let params = this.getParams();
      if (this.showAllClaims === false) {
        params += `&organization=${this.$route.params.orgId}`;
      }
      axios.get(`claims/list?${params}`).then((r) => {
        this.tableData = r.data.Claims;
        this.pager.total = r.data.Found;
        Vue.$loading.off();
        this.$forceUpdate();
      }).catch(() => {
        this.tableData = [];
        this.$notify.error('Ошибка при получении списка жалоб.');
        Vue.$loading.off();
      });
    },

  },

};
</script>

<style lang="scss">
@import "../../../styles/components/org-admin/common";

.user-org-users-control_usc {
  .usc_cbox {
    .el-checkbox__inner:hover,
    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: $color-1;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: $color-1;
      border-color: $color-1;
    }
  }
  .usc_msg {
    border-color: $color-2;
  }
  .oaf_submits {
    margin-top: 10px !important;
  }
  .usc_msg-btn {
    margin: 10px;
    width: 210px;
  }
  .usc_review-claim-win {
    .el-dialog {
      max-width: 700px;
    }
  }
  .usc_win-row {
    margin-bottom: 10px;
    &.usc_win-row--inline {
      .usc_win-label,
      .usc_win-text {
        display: inline-block;
      }
      .usc_win-label {
        margin: 0 5px 0 0;
      }
    }
    .usc_win-label {
      font-weight: 600;
      margin-bottom: 10px;
    }
    .usc_win-text {
      font-weight: 400;
    }
  }
  .usc_td-info {
    display: block;
    margin-top: 5px;
    color: #aaa;
  }
  .usc_answer-win {
    .buttons-wrap {
      button {
        width: 120px;
        margin: 7px 5px;
        padding: 5px 0;
      }
      button.usc_btn-xl {
        width: 252px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/org-admin/UserOrgClaims.vue